<i18n src="@/locales/models/process_line_exec_output.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>

<template>
  <div class="col-span-2 sm:col-span-1">
    <label class="label-form">
      {{ $t("model.process_line_exec_output.process_line_product") }}
    </label>
    <div v-if="process_line_output_products.length > 0" class="mt-1">
      <select-form
        :options="process_line_output_products"
        v-model="process_line_exec_output.process_line_product_id"
        :is_invalid="isInvalidSelect('process_line_product')"
      />
    </div>
  </div>

  <div class="col-span-2 sm:col-span-1">
    <label class="label-form">
      {{ $t("model.process_line_exec_output.output_code") }}
    </label>
    <div class="mt-1">
      <input
        type="text"
        v-model.trim="process_line_exec_output.output_code"
        :class="['input-text', isInvalid('output_code')]"
      />
    </div>
  </div>

  <div class="col-span-2 sm:col-span-1">
    <label class="label-form">
      {{ $t("model.process_line_exec_output.value") }}
    </label>
    <div class="mt-1">
      <input
        type="text"
        v-model.trim="process_line_exec_output.value"
        :class="['input-text', isInvalid('value')]"
      />
    </div>
  </div>

  <div class="col-span-2 sm:col-span-1">
    <label class="label-form">
      {{ $t("model.process_line_exec_output.unit") }}
    </label>
    <div class="mt-1">
      <input
        type="text"
        v-model="process_line_exec_output.unit"
        :class="['input-text', isInvalid('unit')]"
      />
    </div>
  </div>

  <template v-if="process_line_output_product?.has_exported_batch">
    <div class="col-span-2 sm:col-span-1">
      <label class="label-form">
        {{ $t("model.exported_batch.producer") }}
      </label>
      <div class="mt-1">
        <select-form
          v-if="producers.length > 0"
          :options="producers"
          label="label"
          v-model="process_line_exec_output.exported_batch.producer_id"
          :is_invalid="isInvalidSelect('producer')"
        />
      </div>
    </div>
    <div class="col-span-2 sm:col-span-1">
      <label class="label-form">
        {{ $t("model.exported_batch.crop_field") }}
      </label>
      <div class="mt-1" v-if="crop_fields.length > 1">
        <select-form
          :options="crop_fields"
          v-model="process_line_exec_output.exported_batch.crop_field_id"
          :is_invalid="isInvalidSelect('crop_field')"
        />
      </div>
      <dd class="content-data" v-else-if="crop_fields.length == 1">
        {{ crop_fields[0].name }}
      </dd>
    </div>

    <div
      v-if="agro_exporter_processes.length > 1"
      class="col-span-2 sm:col-span-1"
    >
      <label class="label-form">
        {{ $t("model.exported_batch.agro_exporter_process") }}
      </label>
      <div class="mt-1" v-if="agro_exporter_processes.length > 1">
        <select-form
          :options="agro_exporter_processes"
          v-model="
            process_line_exec_output.exported_batch.agro_exporter_process_id
          "
          :is_invalid="isInvalidSelect('agro_exporter_process')"
        />
      </div>
    </div>

    <template
      v-if="
        process_line_exec_output.exported_batch.packages &&
        process_line_exec_output.exported_batch.packages[0]
      "
    >
      <div class="col-span-2 sm:col-span-1">
        <label class="label-form">
          {{ $t("model.package.exporter_process_crop_package") }}
        </label>
        <div class="mt-1">
          <select-form
            :options="exporter_process_crop_packages"
            label="label"
            v-model="
              process_line_exec_output.exported_batch.packages[0]
                .exporter_process_crop_package_id
            "
            :is_invalid="isInvalidSelect('exporter_process_crop_package')"
          />
        </div>
      </div>

      <div class="col-span-2 sm:col-span-1">
        <label class="label-form">
          {{ $t("model.package.exporter_process_crop_category") }}
        </label>
        <div class="mt-1">
          <select-form
            :options="exporter_process_crop_categories"
            v-model="
              process_line_exec_output.exported_batch.packages[0]
                .exporter_process_crop_category_id
            "
            :is_invalid="isInvalidSelect('agro_exporter_process')"
          />
        </div>
      </div>

      <div class="col-span-2 sm:col-span-1">
        <label class="label-form">
          {{ $t("model.package.exporter_process_crop_size") }}
        </label>
        <div class="mt-1">
          <select-form
            :options="exporter_process_crop_sizes"
            v-model="
              process_line_exec_output.exported_batch.packages[0]
                .exporter_process_crop_size_id
            "
            :is_invalid="isInvalidSelect('agro_exporter_process')"
          />
        </div>
      </div>

      <div class="col-span-2 sm:col-span-1">
        <label class="label-form">
          {{ $t("model.package.exporter_process_brand") }}
        </label>
        <div class="mt-1">
          <select-form
            :options="exporter_process_brands"
            v-model="
              process_line_exec_output.exported_batch.packages[0]
                .exporter_process_brand_id
            "
            :is_invalid="isInvalidSelect('agro_exporter_process')"
          />
        </div>
      </div>
    </template>
  </template>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/exec_steps/new_exec_step.js";

export default {
  name: "PHProcessExecStepsExecStepOutputForm",
  components: {},
  data() {
    return {
      process_line_exec_output: this.modelValue,
      producers: [],
      crop_fields: [],
      agro_exporter_processes: [],
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    process_line_output_products: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Object,
      required: true,
    },
  },
  created() {
    if (this.modelValue.exported_batch?.id) {
      this.fetchProducersFormalized();
      this.fetchAgroExporterProcesses();
      this.fetchCropFields();
    } else if (this.process_line_output_products.length == 1) {
      this.process_line_exec_output.process_line_product_id =
        this.process_line_output_products[0].id;
    }

    if (
      !this.modelValue.exported_batch?.id &&
      this.process_line_exec_output.output_code
    ) {
      this.fetchProducerByCode();
    }
  },
  computed: {
    process_line_output_product: function () {
      return this.process_line_output_products.find(
        (product) =>
          product.id === this.process_line_exec_output.process_line_product_id
      );
    },
    agro_exporter_process: function () {
      return this.agro_exporter_processes.find(
        (process) =>
          process.id ===
          this.process_line_exec_output.exported_batch.agro_exporter_process_id
      );
    },

    exporter_process_crop_packages: function () {
      return this.agro_exporter_process?.exporter_process_crop_packages || [];
    },

    exporter_process_crop_categories: function () {
      return this.agro_exporter_process?.exporter_process_crop_categories || [];
    },

    exporter_process_crop_sizes: function () {
      return this.agro_exporter_process?.exporter_process_crop_sizes || [];
    },

    exporter_process_brands: function () {
      return this.agro_exporter_process?.exporter_process_brands || [];
    },
  },
  methods: {
    fetchProducersFormalized: async function () {
      const response = await Requester.fetchProducersFormalized(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.producers = response.data;
    },

    fetchProducerByCode: async function () {
      const response = await Requester.fetchProducerByCode(
        this.packing_house_id,
        this.packing_house_process_id,
        this.process_line_exec_output.output_code
      );
      this.process_line_exec_output.exported_batch.producer_id =
        response.data.id;
      this.process_line_exec_output.exported_batch.crop_field_id =
        response.data.crop_field_id;
    },

    fetchAgroExporterProcesses: async function () {
      const response = await Requester.fetchAgroExporterProcesses(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.agro_exporter_processes = response.data;
      if (this.agro_exporter_processes.length == 1) {
        this.process_line_exec_output.exported_batch.agro_exporter_process_id =
          this.agro_exporter_processes[0].id;
      }
    },

    fetchCropFields: async function () {
      const response = await Requester.fetchCropFields(
        this.packing_house_id,
        this.packing_house_process_id,
        this.process_line_exec_output.exported_batch.producer_id
      );
      this.crop_fields = response.data;
      if (this.crop_fields.length == 1) {
        this.process_line_exec_output.exported_batch.crop_field_id =
          this.crop_fields[0].id;
      }
    },
  },
  watch: {
    "process_line_exec_output.process_line_product_id": function (newValue) {
      this.process_line_exec_output.unit =
        this.process_line_output_products.find(
          (product) => product.id === newValue
        )?.unit || "";
    },

    "process_line_exec_output.output_code": function (newValue) {
      if (newValue) {
        this.fetchProducerByCode();
      }
    },

    process_line_exec_output: {
      handler(newValue) {
        this.$emit("update:modelValue", newValue);
      },
      deep: true,
    },

    process_line_output_product: function (newValue) {
      if (newValue?.has_exported_batch) {
        this.fetchProducersFormalized();
        this.fetchAgroExporterProcesses();
        this.process_line_exec_output.exported_batch = {
          ...this.process_line_exec_output.exported_batch,
          packages: [],
        };
        if (this.process_line_exec_output.exported_batch.packages.length == 0) {
          this.process_line_exec_output.exported_batch.packages = [
            {
              id: null,
              exporter_process_crop_package_id: null,
              exporter_process_crop_category_id: null,
              exporter_process_crop_size_id: null,
              exporter_process_brand_id: null,
            },
          ];
        } else {
          this.process_line_exec_output.exported_batch.packages =
            this.process_line_exec_output.exported_batch.packages.map((pkg) => {
              return {
                id: pkg.id,
                exporter_process_crop_package_id:
                  pkg.exporter_process_crop_package_id,
                exporter_process_crop_category_id:
                  pkg.exporter_process_crop_category_id,
                exporter_process_crop_size_id:
                  pkg.exporter_process_crop_size_id,
                exporter_process_brand_id: pkg.exporter_process_brand_id,
              };
            });
        }
      } else {
        this.producers = [];
        this.crop_fields = [];
      }
    },

    "process_line_exec_output.exported_batch.producer_id": function (
      new_value
    ) {
      this.process_line_exec_output.exported_batch.crop_field_id = null;
      this.crop_fields = [];
      if (new_value) this.fetchCropFields();
    },
  },
};
</script>
